export default {
  headers: [
    {
      id: 'miniHeader',
      logo: {
        src: 'https://si-homelight.s3.amazonaws.com/sites/plavnik/logo.png',
        url: 'https://changinglatitudesfl.com/',
      },
      breakpoint: 575,
      desktopMenu: {
        type: 'default', // default, split, center, single, one-offs
        disableOnHoverMenuExpand: false,
        logo: {
          show: true,
          reverseOrder: false,
          containerClassName: '',
          imageClassName: '',
        },
        headerClassName: 'on-plavnik-miniHeader',
        headerSectionsClassName: '',
        headerClassNameOverride: '',
        headerSectionsClassNameOverride: '',
        itemClassName: 'on-plavnik-miniHeader-item',
        menuClassName: '',
        menuLabelActiveClassName: '',
        menuItemClassName: '',
        subMenuClassName: '',
        subMenuLabelActiveClassName: '',
        subMenuItemClassName: '',
        items: [
          {
            id: 'plavnik-mini-header-fb-item',
            iconSet: 'fab',
            className: 'facebook-square',
            url: 'https://www.facebook.com/carriecourtneyandcompany',
          },
          {
            id: 'plavnik-mini-header-instagram-item',
            iconSet: 'fab',
            className: 'instagram',
            url: 'https://www.instagram.com/carriecourtneyandcompany',
          },
          {
            id: 'plavnik-mini-header-youtube-item',
            iconSet: 'fab',
            className: 'youtube',
            url: 'https://www.youtube.com/carrieclpm',
          },
          {
            id: 'plavnik-mini-header-pinterest-item',
            iconSet: 'fab',
            className: 'pinterest',
            url: 'https://www.pinterest.com/carriecourtneyandcompany',
          },
        ],
      },
      mobileMenu: {
        logo: {
          show: true,
          containerClassName: '',
          imageClassName: 'on-plavnik-header-logo',
        },
        type: 'mobile-content', // mobile-default, mobile-reversed, mobile-center
        menuOpener: {
          className: '',
          content: 'Open',
          hide: true,
        },
        headerClassName: 'on-plavnik-miniHeader-mobile',
        headerClassNameOverride: '',
        mobileMenuClassName: '',
        itemClassName: 'on-plavnik-miniHeader-mobile-item',
        menuClassName: '',
        menuLabelActiveClassName: '',
        menuItemClassName: '',
        subMenuClassName: '',
        subMenuItemClassName: '',
        headerItems: [
          {
            id: 'plavnik-mobile-mini-header-fb-item',
            iconSet: 'fab',
            className: 'facebook-square',
            url: 'https://www.facebook.com/carriecourtneyandcompany',
          },
          {
            id: 'plavnik-mobile-mini-header-instagram-item',
            iconSet: 'fab',
            className: 'instagram',
            url: 'https://www.instagram.com/carriecourtneyandcompany',
          },
          {
            id: 'plavnik-mobile-mini-header-youtube-item',
            iconSet: 'fab',
            className: 'youtube',
            url: 'https://www.youtube.com/carrieclpm',
          },
          {
            id: 'plavnik-mobile-mini-header-pinterest-item',
            iconSet: 'fab',
            className: 'pinterest',
            url: 'https://www.pinterest.com/carriecourtneyandcompany',
          },
        ],
        items: [],
      },
    },
    {
      id: 'main-header',
      logo: {
        alt: 'logo',
        // src: 'https://si-homelight.s3.amazonaws.com/sites/plavnik/logo.png',
        // url: '/',
      },
      breakpoint: 1200,
      desktopMenu: {
        type: 'default', // default, split, center, single, one-offs
        disableOnHoverMenuExpand: false,
        logo: {
          show: false,
          reverseOrder: false,
          containerClassName: 'on-plavnik-header-logo-container',
          imageClassName: 'on-plavnik-header-logo',
        },
        headerClassName: 'on-plavnik-header',
        headerSectionsClassName: '',
        headerClassNameOverride: '',
        headerSectionsClassNameOverride: '',
        itemClassName: 'on-plavnik-header-item',
        menuClassName: 'on-plavnik-header-menu',
        menuLabelActiveClassName: 'on-plavnik-header-folder-item-open',
        menuItemClassName: 'on-plavnik-header-folder-item',
        subMenuClassName: '',
        subMenuLabelActiveClassName: '',
        subMenuItemClassName: '',
        items: [
          {
            id: 'plavnik-item-buy',
            content: 'BUY',
            menuItems: [
              {
                id: 'plavnik-buy-item-why',
                content: 'Why Buy With Us',
                url: 'https://changinglatitudesfl.com/why-buy-with-us/',
              },
              {
                id: 'plavnik-buy-item-perfect',
                content: 'Perfect Home Finder',
                url: 'https://changinglatitudesfl.com/perfect-home-finder-2/',
              },
              {
                id: 'plavnik-buy-item-property',
                content: 'Property Search',
                url: 'https://changinglatitudesfl.com/properties/',
              },
              {
                id: 'plavnik-buy-item-lifestyle',
                content: 'Lifestyle Search',
                url: 'https://changinglatitudesfl.com/lifestyle-search/',
              },
              {
                id: 'plavnik-buy-item-current',
                content: 'Our Current Listings',
                url: 'https://changinglatitudesfl.com/listings/',
              },
              {
                id: 'plavnik-buy-item-construction',
                content: 'New Construction',
                url: 'https://changinglatitudesfl.com/newly-constructed/',
              },
              {
                id: 'plavnik-buy-item-vacation',
                content: 'Vacation Home',
                url: 'https://changinglatitudesfl.com/vacation-home/',
              },
              {
                id: 'plavnik-buy-item-mortgage',
                content: 'Mortgage Calculator',
                url: 'https://changinglatitudesfl.com/mortgage-calculator-2/',
              },
              {
                id: 'plavnik-buy-item-buyers-guide',
                content: "Buyer's Guides",
                url: 'https://changinglatitudesfl.com/buyers-guides/',
              },
              {
                id: 'plavnik-sell-item-homelight',
                content: 'HomeLight Cash Offer',
                url: 'https://cashoffer.changinglatitudesfl.com',
              },
            ],
          },
          {
            id: 'plavnik-item-sell',
            content: 'SELL',
            menuItems: [
              {
                id: 'plavnik-sell-item-why',
                content: 'Why Sell With Us',
                url: 'https://changinglatitudesfl.com/why-sell-with-us/',
              },
              {
                id: 'plavnik-sell-item-valuation',
                content: 'Personalized Home Valuation',
                url: 'https://changinglatitudesfl.com/personalized-home-valuation/',
              },
              {
                id: 'plavnik-sell-item-instant-valuation',
                content: 'Instant Home Valuation',
                url: 'https://changinglatitudesfl.com/instant-home-valuation/',
              },
              {
                id: 'plavnik-sell-item-instant-offer',
                content: 'Instant Offer',
                url: 'https://changinglatitudesfl.com/instant-offer/',
              },
              {
                id: 'plavnik-sell-item-sellers-guide',
                content: "Seller's Guides",
                url: 'https://changinglatitudesfl.com/sellers-guides/',
              },
              {
                id: 'plavnik-buy-item-homelight',
                content: 'HomeLight Trade-In',
                url: 'https://trade-in.changinglatitudesfl.com',
              },
            ],
          },
          {
            id: 'plavnik-item-areas',
            content: 'AREAS',
            url: 'https://changinglatitudesfl.com/our-areas/',
          },
          {
            id: 'plavnik-item-property-mgt',
            content: 'PROPERTY MGT',
            menuItems: [
              {
                id: 'plavnik-property-mgt-item-owner',
                content: "I'm an Owner",
                url: 'https://changinglatitudesfl.com/im-an-owner-2/',
              },
              {
                id: 'plavnik-property-mgt-item-renter',
                content: "I'm a Renter",
                url: 'https://changinglatitudesfl.com/im-a-renter/',
              },
            ],
          },
          {
            id: 'plavnik-item-about-us',
            content: 'ABOUT US',
            menuItems: [
              {
                id: 'plavnik-about-us-item-members',
                content: 'Team Members',
                url: 'https://changinglatitudesfl.com/team-members/',
              },
              {
                id: 'plavnik-about-us-item-success-stories',
                content: 'Success Stories',
                url: 'https://changinglatitudesfl.com/success-stories-2/',
              },
              {
                id: 'plavnik-about-us-item-testimonials',
                content: 'Testimonials',
                url: 'https://changinglatitudesfl.com/testimonials/',
              },
              {
                id: 'plavnik-about-us-item-awards',
                content: 'Awards',
                url: 'https://changinglatitudesfl.com/awards/',
              },
              {
                id: 'plavnik-about-us-item-partners',
                content: 'Our Partners',
                url: 'https://changinglatitudesfl.com/our-partners/',
              },
              {
                id: 'plavnik-about-us-item-giving-back',
                content: 'Giving Back',
                url: 'https://changinglatitudesfl.com/giving-back-2/',
              },
              {
                id: 'plavnik-about-us-item-join-network',
                content: 'Join Our Preferred Agent Network',
                url: 'https://changinglatitudesfl.com/join-our-preferred-agent-network/',
              },
            ],
          },
          {
            id: 'plavnik-item-carreer',
            content: 'CAREER',
            menuItems: [
              {
                id: 'plavnik-carreer-item-join-team',
                content: 'Join Our Team',
                url: 'https://changinglatitudesfl.com/join-our-team-3/',
              },
              {
                id: 'plavnik-carreer-item-form',
                content: 'Application Form',
                url: 'https://changinglatitudesfl.com/application-form/',
              },
              {
                id: 'plavnik-carreer-item-agent-success',
                content: 'Agent Success Stories',
                url: 'https://changinglatitudesfl.com/agent-success-stories-2/',
              },
              {
                id: 'plavnik-carreer-item-strategy',
                content: 'Strategy Session',
                url: 'https://changinglatitudesfl.com/strategy-session/',
              },
              {
                id: 'plavnik-carreer-item-get-licensed',
                content: 'Get Licensed',
                url: 'https://changinglatitudesfl.com/get-licensed/',
              },
              {
                id: 'plavnik-carreer-item-events',
                content: 'Events',
                url: 'https://changinglatitudesfl.com/events/',
              },
            ],
          },
          {
            id: 'plavnik-item-blog',
            content: 'BLOG',
            url: 'https://changinglatitudesfl.com/blog/',
          },
          {
            id: 'plavnik-item-contact-us',
            content: 'CONTACT US',
            url: 'https://changinglatitudesfl.com/contact-us/',
          },
        ],
      },
      mobileMenu: {
        logo: {
          show: false,
          containerClassName: '',
          imageClassName: 'on-plavnik-header-logo',
        },
        type: 'mobile-default', // mobile-default, mobile-reversed, mobile-center
        menuOpener: {
          type: 'hamburger',
          className: '',
          hide: false,
          reverse: false,
        },
        headerClassName: 'on-plavnik-header-mobile',
        headerSectionsClassName: '',
        headerClassNameOverride: '',
        headerSectionsClassNameOverride: '',
        mobileMenuClassName: 'on-plavnik-header-mobile-menu',
        itemClassName: 'on-plavnik-header-mobile-item',
        menuClassName: 'on-plavnik-header-mobile-folder',
        menuLabelActiveClassName: 'on-plavnik-header-mobile-label-active',
        menuItemClassName: 'on-plavnik-header-mobile-folder-item',
        subMenuClassName: '',
        subMenuItemClassName: '',
        headerItems: [],
        items: [
          {
            id: 'plavnik-mobile-item-menu',
            content: 'MENU',
          },
          {
            id: 'plavnik-mobile-item-buy',
            content: 'BUY',
            menuItems: [
              {
                id: 'plavnik-mobile-buy-item-why',
                content: 'Why Buy With Us',
                url: 'https://changinglatitudesfl.com/why-buy-with-us/',
              },
              {
                id: 'plavnik-mobile-buy-item-perfect',
                content: 'Perfect Home Finder',
                url: 'https://changinglatitudesfl.com/perfect-home-finder-2/',
              },
              {
                id: 'plavnik-mobile-buy-item-property',
                content: 'Property Search',
                url: 'https://changinglatitudesfl.com/properties/',
              },
              {
                id: 'plavnik-mobile-buy-item-lifestyle',
                content: 'Lifestyle Search',
                url: 'https://changinglatitudesfl.com/lifestyle-search/',
              },
              {
                id: 'plavnik-mobile-buy-item-current',
                content: 'Our Current Listings',
                url: 'https://changinglatitudesfl.com/listings/',
              },
              {
                id: 'plavnik-mobile-buy-item-construction',
                content: 'New Construction',
                url: 'https://changinglatitudesfl.com/newly-constructed/',
              },
              {
                id: 'plavnik-mobile-buy-item-vacation',
                content: 'Vacation Home',
                url: 'https://changinglatitudesfl.com/vacation-home/',
              },
              {
                id: 'plavnik-mobile-buy-item-mortgage',
                content: 'Mortgage Calculator',
                url: 'https://changinglatitudesfl.com/mortgage-calculator-2/',
              },
              {
                id: 'plavnik-mobile-buy-item-buyers-guide',
                content: "Buyer's Guides",
                url: 'https://changinglatitudesfl.com/buyers-guides/',
              },
              {
                id: 'plavnik-mobile-sell-item-homelight',
                content: 'HomeLight Cash Offer',
                url: 'https://cashoffer.changinglatitudesfl.com',
              },
            ],
          },
          {
            id: 'plavnik-mobile-item-sell',
            content: 'SELL',
            menuItems: [
              {
                id: 'plavnik-mobile-sell-item-why',
                content: 'Why Sell With Us',
                url: 'https://changinglatitudesfl.com/why-sell-with-us/',
              },
              {
                id: 'plavnik-mobile-sell-item-valuation',
                content: 'Personalized Home Valuation',
                url: 'https://changinglatitudesfl.com/personalized-home-valuation/',
              },
              {
                id: 'plavnik-mobile-sell-item-instant-valuation',
                content: 'Instant Home Valuation',
                url: 'https://changinglatitudesfl.com/instant-home-valuation/',
              },
              {
                id: 'plavnik-mobile-sell-item-instant-offer',
                content: 'Instant Offer',
                url: 'https://changinglatitudesfl.com/instant-offer/',
              },
              {
                id: 'plavnik-mobile-sell-item-sellers-guide',
                content: "Seller's Guides",
                url: 'https://changinglatitudesfl.com/sellers-guides/',
              },
              {
                id: 'plavnik-mobile-buy-item-homelight',
                content: 'HomeLight Trade-In',
                url: 'https://trade-in.changinglatitudesfl.com',
              },
            ],
          },
          {
            id: 'plavnik-mobile-item-areas',
            content: 'AREAS',
            url: 'https://changinglatitudesfl.com/our-areas/',
          },
          {
            id: 'plavnik-mobile-item-property-mgt',
            content: 'PROPERTY MGT',
            menuItems: [
              {
                id: 'plavnik-mobile-property-mgt-item-owner',
                content: "I'm an Owner",
                url: 'https://changinglatitudesfl.com/im-an-owner-2/',
              },
              {
                id: 'plavnik-mobile-property-mgt-item-renter',
                content: "I'm a Renter",
                url: 'https://changinglatitudesfl.com/im-a-renter/',
              },
            ],
          },
          {
            id: 'plavnik-mobile-item-about-us',
            content: 'ABOUT US',
            menuItems: [
              {
                id: 'plavnik-mobile-about-us-item-members',
                content: 'Team Members',
                url: 'https://changinglatitudesfl.com/team-members/',
              },
              {
                id: 'plavnik-mobile-about-us-item-success-stories',
                content: 'Success Stories',
                url: 'https://changinglatitudesfl.com/success-stories-2/',
              },
              {
                id: 'plavnik-mobile-about-us-item-testimonials',
                content: 'Testimonials',
                url: 'https://changinglatitudesfl.com/testimonials/',
              },
              {
                id: 'plavnik-mobile-about-us-item-awards',
                content: 'Awards',
                url: 'https://changinglatitudesfl.com/awards/',
              },
              {
                id: 'plavnik-mobile-about-us-item-partners',
                content: 'Our Partners',
                url: 'https://changinglatitudesfl.com/our-partners/',
              },
              {
                id: 'plavnik-mobile-about-us-item-giving-back',
                content: 'Giving Back',
                url: 'https://changinglatitudesfl.com/giving-back-2/',
              },
              {
                id: 'plavnik-mobile-about-us-item-join-network',
                content: 'Join Our Preferred Agent Network',
                url: 'https://changinglatitudesfl.com/join-our-preferred-agent-network/',
              },
            ],
          },
          {
            id: 'plavnik-mobile-item-carreer',
            content: 'CAREER',
            menuItems: [
              {
                id: 'plavnik-mobile-carreer-item-join-team',
                content: 'Join Our Team',
                url: 'https://changinglatitudesfl.com/join-our-team-3/',
              },
              {
                id: 'plavnik-mobile-carreer-item-form',
                content: 'Application Form',
                url: 'https://changinglatitudesfl.com/application-form/',
              },
              {
                id: 'plavnik-mobile-carreer-item-agent-success',
                content: 'Agent Success Stories',
                url: 'https://changinglatitudesfl.com/agent-success-stories-2/',
              },
              {
                id: 'plavnik-mobile-carreer-item-strategy',
                content: 'Strategy Session',
                url: 'https://changinglatitudesfl.com/strategy-session/',
              },
              {
                id: 'plavnik-mobile-carreer-item-get-licensed',
                content: 'Get Licensed',
                url: 'https://changinglatitudesfl.com/get-licensed/',
              },
              {
                id: 'plavnik-mobile-carreer-item-events',
                content: 'Events',
                url: 'https://changinglatitudesfl.com/events/',
              },
            ],
          },
          {
            id: 'plavnik-mobile-item-blog',
            content: 'BLOG',
            url: 'https://changinglatitudesfl.com/blog/',
          },
          {
            id: 'plavnik-mobile-item-contact-us',
            content: 'CONTACT US',
            url: 'https://changinglatitudesfl.com/contact-us/',
          },
          {
            id: 'plavnik-mobile-social',
            menuItems: [
              {
                id: 'plavnik-mobile-header-fb-item',
                iconSet: 'fab',
                className: 'facebook-square',
                url: 'https://www.facebook.com/CarrieCourtneyandCompany/',
              },
              {
                id: 'plavnik-mobile-header-gplus-item',
                iconSet: 'fab',
                className: 'google-plus-square',
                url: 'https://www.realtor.com/realestateagents/carrie-courtney-&-company_davenport_fl_759571_185694727',
              },
              {
                id: 'plavnik-mobile-header-youtube-item',
                iconSet: 'fab',
                className: 'youtube',
                url: 'https://www.youtube.com/carrieclpm',
              },
              {
                id: 'plavnik-mobile-header-pinterest-item',
                iconSet: 'fab',
                className: 'pinterest',
                url: 'https://www.pinterest.com/carriecourtneyandcompany',
              },
              {
                id: 'plavnik-mobile-header-instagram-item',
                iconSet: 'fab',
                className: 'instagram',
                url: 'https://www.instagram.com/carriecourtneyandcompany',
              },
            ],
          },
        ],
      },
    },
  ],
  footers: {
    id: 'on-plavnik-footer-wrapper',
    className: 'on-plavnik-footer-wrapper',
    footer: [
      {
        id: 'plavnik-main-footer',
        className: 'on-plavnik-footer on-plavnik-main-footer',
        sectionClassName: 'on-plavnik-footer-container',
        columns: [
          {
            id: 'plavnik-main-footer-links',
            className: 'on-plavnik-main-footer-column',
            items: [
              {
                id: 'plavnik-heading-links',
                type: 'heading',
                elementType: 'h1',
                data: 'Quick Links',
              },
              {
                id: 'plavnik-links-menu',
                type: 'menu',
                items: [
                  {
                    id: 'plavnik-links-menu-item-about',
                    data: 'ABOUT US',
                    url: 'https://changinglatitudesfl.com/about-us/',
                  },
                  {
                    id: 'plavnik-links-menu-item-members',
                    data: 'TEAM MEMBERS',
                    url: 'https://changinglatitudesfl.com/team-members/',
                  },
                  {
                    id: 'plavnik-links-menu-item-awards',
                    data: 'AWARDS',
                    url: 'https://changinglatitudesfl.com/awards/',
                  },
                  {
                    id: 'plavnik-links-menu-item-stories',
                    data: 'SUCCESS STORIES',
                    url: 'https://changinglatitudesfl.com/success-stories-2/',
                  },
                  {
                    id: 'plavnik-links-menu-item-testimonials',
                    data: 'TESTIMONIALS',
                    url: 'https://changinglatitudesfl.com/testimonials/',
                  },
                  {
                    id: 'plavnik-links-menu-item-contact-us',
                    data: 'CONTACT US',
                    url: 'https://changinglatitudesfl.com/contact-us/',
                  },
                  {
                    id: 'plavnik-links-menu-item-join',
                    data: 'JOIN OUR PREFERRED AGENT NETWORK',
                    url: 'https://changinglatitudesfl.com/join-our-preferred-agent-network/',
                  },
                ],
              },
            ],
          },
          {
            id: 'plavnik-main-footer-services',
            className: 'on-plavnik-main-footer-column',
            items: [
              {
                id: 'plavnik-heading-services',
                type: 'heading',
                elementType: 'h1',
                data: 'Our Services',
              },
              {
                id: 'plavnik-services-menu',
                type: 'menu',
                items: [
                  {
                    id: 'plavnik-services-menu-item-buyers-guides',
                    data: 'BUYER’S GUIDES',
                    url: 'https://changinglatitudesfl.com/buyers-guides/',
                  },
                  {
                    id: 'plavnik-services-menu-item-sellers-guides',
                    data: 'SELLER’S GUIDES',
                    url: 'https://changinglatitudesfl.com/sellers-guides/',
                  },
                  {
                    id: 'plavnik-services-menu-item-lifestyle-search',
                    data: 'LIFESTYLE SEARCH',
                    url: 'https://changinglatitudesfl.com/lifestyle-search/',
                  },
                  {
                    id: 'plavnik-services-menu-item-perfect-home',
                    data: 'PERFECT HOME FINDER',
                    url: 'https://changinglatitudesfl.com/perfect-home-finder-2/',
                  },
                  {
                    id: 'plavnik-services-menu-item-home-worth',
                    data: 'WHAT’S MY HOME WORTH',
                    url: 'https://changinglatitudesfl.com/instant-home-valuation/',
                  },
                  {
                    id: 'plavnik-services-menu-item-',
                    data: 'MORTGAGE CALCULATOR',
                    url: 'https://changinglatitudesfl.com/mortgage-calculator-2/',
                  },
                ],
              },
            ],
          },
          {
            id: 'plavnik-main-footer-info',
            className: 'on-plavnik-main-footer-column plavnik-main-footer-info-column',
            items: [
              {
                id: 'plavnik-heading-info',
                type: 'heading',
                elementType: 'h1',
                data: 'Contact Info',
              },
              {
                id: 'plavnik-info-office',
                type: 'heading',
                elementType: 'b',
                data: 'CORPORATE OFFICE:',
              },
              {
                id: 'plavnik-info-office-address',
                type: 'heading',
                elementType: 'p',
                data: '14650 GATORLAND DRIVE, #3, ORLANDO, FL 32837',
              },
              {
                id: 'plavnik-info-locations',
                type: 'heading',
                elementType: 'b',
                data: 'LOCATIONS:',
              },
              {
                id: 'plavnik-info-address',
                type: 'heading',
                elementType: 'p',
                data: '1101 MIRANDA LANE, SUITE #131, KISSIMMEE, FL 34741 ',
              },
              {
                id: 'plavnik-info-tel',
                type: 'heading',
                elementType: 'p',
                data: 'TEL:',
              },
              {
                id: 'plavnik-info-number',
                type: 'heading',
                data: '(407) 922-9767',
                url: 'tel:(407)922-9767',
              },
              {
                id: 'plavnik-info-email',
                type: 'heading',
                elementType: 'p',
                data: 'EMAIL:',
              },
              {
                id: 'plavnik-info-email-address',
                type: 'heading',
                elementType: 'b',
                data: 'CARRIE@CHANGINGLATITUDESFL.COM',
                url: 'mailto:CARRIE@CHANGINGLATITUDESFL.COM',
              },
            ],
          },
        ],
      },
      {
        id: 'plavnik-image-footer',
        className: 'on-plavnik-footer plavnik-logo-footer',
        sectionClassName: 'on-plavnik-footer-container',
        columns: [
          {
            id: 'plavnik-image-footer',
            className: 'on-plavnik-logo-column',
            items: [
              {
                id: 'plavnik-footer-logo',
                type: 'image',
                url: 'https://assets.thesparksite.com/uploads/sites/1937/2022/03/logo01-final-edit4-transparent-1-500xAUTO.fit.png',
              },
              {
                id: 'plavnik-footer-socials',
                className: 'on-plavnik-footer-socials',
                type: 'socialIcons',
                items: [
                  {
                    id: 'plavnik-footer-instagram',
                    iconTypeClassName: 'fab',
                    iconClassName: 'instagram',
                    url: 'https://www.instagram.com/carriecourtneyandcompany/',
                    data: 'Instagram',
                  },
                  {
                    id: 'plavnik-footer-facebook',
                    iconTypeClassName: 'fab',
                    iconClassName: 'facebook-f',
                    url: 'https://www.facebook.com/CarrieCourtneyandCompany/',
                    data: 'Facebook',
                  },
                  {
                    id: 'plavnik-footer-youtube',
                    iconTypeClassName: 'fab',
                    iconClassName: 'youtube',
                    url: 'https://www.youtube.com/channel/UC8bdMoZkWDUZ4OrC1t_QQUA',
                    data: 'Youtube',
                  },
                  {
                    id: 'plavnik-footer-pinterest',
                    iconTypeClassName: 'fab',
                    iconClassName: 'pinterest',
                    url: 'https://www.pinterest.ph/carriecourtneyandcompany/_created/',
                    data: 'Pinterest',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  substitute: {},
  replace: {},
  siteData: {
    agency: 'The Changing Latitudes Team',
    agentDescription: 'Top agents in Central Florida',
    agentAvatar: 'https://si-homelight.s3.amazonaws.com/sites/plavnik/agent.jpg',
    heroBackground: 'https://si-homelight.s3.amazonaws.com/sites/plavnik/hero-bg.jpg',
    expressFee: '1.5%',
  },
};
